import { useCallback } from "react";

interface ScrollOptions {
  elementId: string;
  delay?: number;
  offset?: number;
}

export const useAppScroll = () => {
  const scrollTo = useCallback((options: ScrollOptions) => {
    const { elementId, delay = 0, offset = 0 } = options;

    setTimeout(() => {
      const element = document.getElementById(elementId);
      if (!element) {
        return;
      }

      const position = element.getBoundingClientRect().top + window.scrollY;
      window.scrollTo({
        top: position - offset,
        behavior: "smooth",
      });
    }, delay);
  }, []);

  return { scrollTo };
};

export default useAppScroll;
